import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

// action creators
import { doctorCreate } from '../../../actions/doctorActions';
import { tooltipHide, tooltipShow } from '../../../actions/tooltipActions';

// components
import DoctorTooltipForm from './_DoctorTooltipForm';
import { Tooltip } from '../../shared/_tooltip';

// constants
const TOOLTIP_ID = 'createDoctorTooltip';

class CreateDoctorTooltip extends React.Component {
  static propTypes = {
    createDoctor: PropTypes.func.isRequired,
    hideTooltip:  PropTypes.func.isRequired,
    showTooltip:  PropTypes.func.isRequired
  }

  render() {
    const { hideTooltip } = this.props;

    return (
      <div className='tooltip-button manager__doctor-index__create-doctor-button'>
        <i className='fa fa-plus-circle manager-doctors__add-icon' onClick={ this._handleShowCreateDoctorTooltip } />
        <Tooltip className='manager__doctor-index__create-doctor-tooltip'
          header='Create Doctor'
          id={ TOOLTIP_ID }>
          <DoctorTooltipForm onClose={ hideTooltip } onSubmit={ this._handleCreateDoctor } />
        </Tooltip>
      </div>
    );
  }

  // private

  _handleCreateDoctor             = this._handleCreateDoctor.bind(this);
  _handleShowCreateDoctorTooltip  = this._handleShowCreateDoctorTooltip.bind(this);

  _handleCreateDoctor(attributes) {
    const { createDoctor } = this.props;

    const params = {
      ...attributes, tooltipId: TOOLTIP_ID
    };

    createDoctor(params);
  }

  _handleShowCreateDoctorTooltip() {
    const { showTooltip } = this.props;

    showTooltip();
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    createDoctor: (params) => {
      dispatch(doctorCreate(params));
    },

    hideTooltip: () => {
      dispatch(tooltipHide({ id: TOOLTIP_ID }));
    },

    showTooltip: () => {
      dispatch(tooltipShow({ id: TOOLTIP_ID }));
    }
  };
};

export default connect(null, mapDispatchToProps)(CreateDoctorTooltip);



// WEBPACK FOOTER //
// ./app/components/managers/doctors/_CreateDoctorTooltip.jsx